// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__gHwT6","left":"StickyBox_left__3OJLI","right":"StickyBox_right__1BsKH"};